/* eslint-disable */
window.addEventListener('DOMContentLoaded', () => {
  const controls = document.querySelectorAll('[data-navigation-button]');
  document.querySelectorAll('[data-slideshow-container]').forEach((slideshow) => {
    slideshow.classList.add('is-loaded');

    const nextSlide = (currentSlide) => {
      // if there is a next slide set the next slide to active, if not set the first slide to active
      return currentSlide.nextElementSibling ? currentSlide.nextElementSibling : currentSlide.parentElement.firstElementChild;
    }

    const resetSlides = (activeSlide) => {
      // remove classes from all but active slide
      activeSlide.parentElement.querySelectorAll('[data-slideshow-slide]').forEach((slide) => {
        if (slide !== activeSlide) {
          slide.classList.remove('is-active', 'is-animated');
        }
      });
    }

    const setActiveSlide = (slide) => {
      slideshow.dataset.slideshowActive = slide.id;
      slide.classList.add('is-active');
      updateNavigation(slide.id);
    }

    const updateNavigation = (activeSlideId) => {
      controls.forEach((navElement) => {
        if (navElement.hash === '#' + activeSlideId) {
          navElement.classList.add('is-active');
        } else {
          navElement.classList.remove('is-active');
        }
      });
    }

    controls.forEach((control) => {
      control.addEventListener('click', (e) => {
        e.preventDefault();
        const targetSlide = document.querySelector(e.target.hash);
        resetSlides(targetSlide);
        setActiveSlide(targetSlide);
      });
    });

    slideshow.querySelectorAll(':scope > [data-slideshow-slide]').forEach((slide) => {
      slide.addEventListener('animationstart', () => {
        slideshow.dataset.slideshowAnimation = 'running';
        const next = nextSlide(slide);
        next.classList.add('is-animated');
        updateNavigation(next.id);
      });

      slide.addEventListener('animationend', () => {
        const targetSlide = nextSlide(slide);
        resetSlides(targetSlide);
        setActiveSlide(targetSlide);
        slideshow.dataset.slideshowAnimation = 'complete';
      });
    });

    slideshow.addEventListener('mouseover', () => {
      if (slideshow.dataset.slideshowAnimation == 'complete') {
        const currentSlide = document.querySelector('[data-slideshow-container] > [data-slideshow-slide].is-active');
        currentSlide.style.animationPlayState = 'paused';
      }
    });

    slideshow.addEventListener('mouseleave', () => {
      const currentSlide = document.querySelector('[data-slideshow-container] > [data-slideshow-slide].is-active');
      currentSlide.style.animationPlayState = 'running';
    });
  });
});
